import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NotificationType } from '../../../utils/hooks/useNotificator/useNotificator.types';
import { GenericNotification } from './GenericNotification';

export const cantCopyHereNotification =
  () =>
  ({ notification }) =>
    (
      <GenericNotification
        notification={notification}
        text={<FormattedMessage id="files-manager.cant-copy-here-notification" />}
        type={NotificationType.Destructive}
      />
    );
